import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
// import App from './App';
import App2 from './App2';
// import PortfolioPage from './PortfolioPage';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import ReactGA from "react-ga4"


const TrackingID = "G-KXD76PZ168";
ReactGA.initialize(TrackingID, {
  debug: true,
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <React.StrictMode>
     <App2 />
    </React.StrictMode>
  </Router>

);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();



